import Map from "ol/Map";
import React from "react";

export interface ContextType {
    map?: Map;
}

export const MapContext = React.createContext({} as ContextType);